import { Box, Button, Modal, Stack, Typography } from "@mui/material";
import { useLangContext } from "../../../context/langContext";
import { ReactNode } from "react";

interface IMuiBaseModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subTitle?: string;
  children?: ReactNode;
  hasCloseIcon?: boolean;
  size?: "sm" | "md" | "lg";
}

const width = {
  md: { xs: "95%", sm: "60%", md: "35vw" },
  lg: { xs: "98%", sm: "60%", md: "53vw" },
  sm: { xs: "95%", sm: "60%", md: "30vw" },
};

export default function MuiBaseModal({
  onClose,
  open,
  title,
  children,
  subTitle,
  hasCloseIcon,
  size = "md",
}: Readonly<IMuiBaseModalProps>) {
  const { dir } = useLangContext();
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        position: "fixed",
        zIndex: "1300",
        inset: "0",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        dir={dir}
        sx={{
          width: width[size],
          backgroundColor: (theme) => theme.palette.gray.bg,
          border: "none",
          borderRadius: "16px",
          paddingX: "20px",
          pb: "24px",
        }}
      >
        <Stack
          p="0"
          m="0"
          boxSizing={"border-box"}
          direction="row"
          justifyContent={hasCloseIcon ? "space-between" : "start"}
          alignItems="center"
          width="100%"
          sx={{
            borderBottomStyle: "dashed",
            borderBottomWidth: "2px",
            borderBottomColor: (theme) => theme.palette.gray[400],
          }}
        >
          <Typography
            variant="h6MediumBold"
            component="p"
            sx={{
              width: "100%",
              py: "24px",
              color: (theme) => theme.palette.dominant.main,
            }}
          >
            {title}
          </Typography>
          <Box
            onClick={onClose}
            component={Button}
            size="small"
            sx={{
              bgcolor: "transparent",
              "&:hover": {
                bgcolor: "transparent",
              },
            }}
          >
            <img src="/images/close.svg" />
          </Box>
        </Stack>

        {subTitle && (
          <Typography
            py="24px"
            component="p"
            variant="footerMediumBold"
            color={(theme) => theme.palette.dominant[400]}
          >
            {subTitle}
          </Typography>
        )}
        <Stack
          sx={{
            overflowY: "auto",
            maxHeight: "70vh",
          }}
          mt={!subTitle ? "24px" : "0"}
        >
          {children}
        </Stack>
      </Box>
    </Modal>
  );
}
